module.exports = __webpack_public_path__ + "img/home_banner_pic-image.54660640.jpg";